import { SyntheticEvent } from 'react';

import { Dayjs } from 'dayjs';
import { FunctionResponse } from 'generated';
import { Control, Controller } from 'react-hook-form';

import FunctionSelector from 'components/shared/FunctionSelector';

type Props = {
  control: Control<any>;
  name: string;
  onChange?: (
    event: SyntheticEvent<Element, Event>,
    dht?: FunctionResponse | FunctionResponse[]
  ) => void;
  label: string;
  required?: boolean;
  value?: number;
  fullWidth?: boolean;
  startDate: Dayjs;
  endDate: Dayjs;
  onlyPreferred: boolean;
  organizationalUnitId?: number;
  onlySelectable: boolean;
};

export type Option = {
  id?: number;
  value?: number;
  label: string;
  description?: string;
  code?: string;
};

const ControlledFunctionSelector = (props: Props) => {
  const {
    control,
    name,
    label,
    required,
    fullWidth,
    startDate,
    endDate,
    onlyPreferred,
    organizationalUnitId,
    onlySelectable
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FunctionSelector
          field={field}
          fieldState={fieldState}
          label={label}
          required={required}
          fullWidth={fullWidth}
          startDate={startDate}
          endDate={endDate}
          onlyPreferred={onlyPreferred}
          organizationalUnitId={organizationalUnitId}
          onlySelectable={onlySelectable}
        />
      )}
    />
  );
};

export default ControlledFunctionSelector;
